import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7236356f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-lt" }
const _hoisted_3 = { class: "login-ct" }
const _hoisted_4 = { class: "login-ct-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_6 = {
  class: "top clearfix",
  style: {"position":"absolute","right":"30px","top":"30px"}
}
const _hoisted_7 = {
  class: "imgbox000 fr",
  style: {"position":"relative"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "txttips"
}
const _hoisted_11 = {
  key: 3,
  class: "txttips"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-ct-box-title" }, "欢迎登录", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 还没有账号？")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-ct-box-title" }, "微信扫码登录", -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 还没有账号？")
const _hoisted_18 = { class: "login-rt" }
const _hoisted_19 = { class: "login-rt-box" }
const _hoisted_20 = { class: "login-rt-box" }
const _hoisted_21 = { class: "login-rt-box" }

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';
import { Avatar, Lock } from '@element-plus/icons-vue';
import socket from '@/utils/websocket';

import tool from '@/utils/tool';
import router from '@/router/index';
import { ComponentInternalInstance, getCurrentInstance } from 'vue';

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

store.dispatch('loginModule/getAesKey');

const loginFormRef = ref<FormInstance>();
const showUiIndex = ref(1);
const date = new Date();
const clientId =  date.getFullYear() +""+ (date.getMonth() + 1)  +""+ date.getDate() +""+ date.getHours()  +""+ date.getMinutes() +""+ date.getSeconds() + "" + date.getMilliseconds() + "" + Math.floor(Math.random() * 1000);

const loginQrcode = ref(
  'https://sqmjw.com/design/weixinWapApi/getLoginAuthorizeQrCode?clientId=' + clientId
);

const reloadLoginQrcode = () => {
  loginQrcode.value =
    'https://sqmjw.com/design/weixinWapApi/getLoginAuthorizeQrCode?clientId=' + clientId;
};

const validateUserName = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入用户名'));
  } else {
    callback();
  }
};

const validatePassword = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入密码'));
  } else {
    callback();
  }
};

const ustore = useStore();
const isMustValid = ustore.state.loginModule.isMustValid;

const bindData = reactive({
  isMustValid: isMustValid,
  validationCodeUrl: tool.url('/login/valiationCode?v=' + Math.random()),
});

const refreshValidationCodeEvent = (event: InputEvent) => {
  bindData.validationCodeUrl = tool.url(
    '/login/valiationCode?v=' + Math.random()
  );
};

const loginForm = reactive({
  userName: '',
  password: '',
  validationCode: '',
});

const rules = reactive({
  userName: [{ validator: validateUserName, trigger: 'blur' }],
  password: [{ validator: validatePassword, trigger: 'blur' }],
});

const changeUserNameEvent = (event: InputEvent) => {
  store.dispatch('loginModule/getErrorNumberByMemberCode', loginForm).then(
    (data) => {
      //成功
      if (data.result >= 3) {
        bindData.isMustValid = true;
      } else {
        bindData.isMustValid = false;
      }
    },
    (error) => {
      console.log(error.msg);
      bindData.isMustValid = false;
    }
  );
};

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store.dispatch('loginModule/saveLogin', loginForm).then(
        (data) => {
          //成功
          ustore.state.loginMember = data.result;
          ElMessage.success('登录成功.');
          //router.push({ path: "/" });
          router.go(-1);
        },
        (error) => {
          store.dispatch('loginModule/getAesKey');
          if (error.result != null && error.result >= 3) {
            //输错3次后，必须填写验证码
            bindData.isMustValid = true;
            bindData.validationCodeUrl = tool.url(
              '/login/valiationCode?v=' + Math.random()
            );
            loginForm.validationCode = '';
          }
          ElMessageBox.alert(error.msg, '系统消息', {
            confirmButtonText: '关闭',
            callback: (action: Action) => {},
          });
        }
      );
    } else {
      console.log('error submit!');
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log('exec...resetForm');
  if (!formEl) return;
  formEl.resetFields();
};

const handleToRegister = () => {
  router.push('/frontDesk/register/all');
};

const handleToBack = () => {
  router.push('/');
};

const showUiChange = (id: number) => {
  showUiIndex.value = id;
};

const { appContext } = getCurrentInstance() as ComponentInternalInstance;
const websocketInit = (clientId: string) => {
  //const clientId = tool.getCookieValue("JSESSIONID");
  //const clientId = appContext.config.globalProperties.cookies.get('JSESSIONID');
  socket.init(
    clientId,
    'wss://www.sqmjw.com/design/websocket/login',
    (message: any) => {
      console.log('wss-message: ' + message);
      // 接收到了一个消息
      if (message.data === 'cmd:expiration') {
        socket.send('cmd:close');
        ElMessage.success('Session已过期，请重新登录.');
      }
      if (message.data === 'cmd:refreshqrcode') {
        //操作超时，微信二维码过期
        reloadLoginQrcode();
        ElMessage.success('二维码自动刷新成功！');
      }
      if (message.data.indexOf('cmd:authlogin') >= 0) {
        //	$.session.set("firstLogin", "Y");
        var args = message.data.split(':')[2].split('&');
        var sessionKey = args[0];
        var token = args[1];
        var loginForm = { sessionKey: sessionKey, token: token };
        store.dispatch('loginModule/loginByToken', loginForm).then(
          (data) => {
            //成功
            ustore.state.loginMember = data.result;
            ElMessage.success('登录成功.');
            router.push('/frontDesk/index');
          },
          (error) => {
            ElMessageBox.alert(error.msg, '系统消息', {
              confirmButtonText: '关闭',
              callback: (action: Action) => {},
            });
          }
        );
      }
      if (message.data.indexOf('cmd:redirect') >= 0) {
        console.log(message.data);
        //var uri = message.data.split(':')[2];
        //window.location.href = WEB_URL+uri;
      }
      if (message.data.indexOf('cmd:logout') >= 0) {
        ElMessage.success('您的账号已经在另一处登录,您被迫下线!');
      }
    }
  );
};

websocketInit(clientId);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "login-box" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_image, {
            class: "header-lt-logo",
            src: require('@/assets/fd/login_bg.jpg')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(ElButton), {
              type: "text",
              class: "login-ct-box-return",
              onClick: handleToBack
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (showUiIndex.value == 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "pt",
                      style: {"cursor":"pointer"},
                      src: require('@/assets/fd/diannao.jpg'),
                      title: "切换到PC填写登录",
                      alt: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showUiChange(1)))
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                (showUiIndex.value == 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "pt",
                      style: {"cursor":"pointer"},
                      src: require('@/assets/fd/erweima.jpg'),
                      title: "切换到扫码登录",
                      alt: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showUiChange(2)))
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (showUiIndex.value == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "微信扫码登录"))
                  : _createCommentVNode("", true),
                (showUiIndex.value == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "PC填写登录"))
                  : _createCommentVNode("", true)
              ])
            ]),
            (showUiIndex.value == 1)
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  ref_key: "loginFormRef",
                  ref: loginFormRef,
                  model: _unref(loginForm),
                  "status-icon": "",
                  rules: _unref(rules),
                  class: "loginForm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createVNode(_component_el_form_item, {
                      class: "login-ct-box-ipt",
                      prop: "userName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(loginForm).userName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(loginForm).userName) = $event)),
                          type: "text",
                          autocomplete: "off",
                          onBlur: changeUserNameEvent,
                          placeholder: "请输入会员编码",
                          "prefix-icon": _unref(Avatar)
                        }, null, 8, ["modelValue", "prefix-icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "login-ct-box-ipt",
                      prop: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(loginForm).password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(loginForm).password) = $event)),
                          type: "password",
                          autocomplete: "off",
                          placeholder: "请输入密码",
                          "prefix-icon": _unref(Lock)
                        }, null, 8, ["modelValue", "prefix-icon"])
                      ]),
                      _: 1
                    }),
                    (_unref(bindData).isMustValid)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "login-ct-box-ipt",
                          prop: "validationCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 11 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(loginForm).validationCode,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(loginForm).validationCode) = $event)),
                                  type: "text",
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_image, {
                                  style: {"width":"100px","height":"30px"},
                                  src: _unref(bindData).validationCodeUrl,
                                  onClick: refreshValidationCodeEvent,
                                  fit: "fill"
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, { class: "login-ct-box-btn" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), {
                          type: "primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(loginFormRef.value)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", { class: "login-ct-box-res" }, [
                      _hoisted_14,
                      _createElementVNode("span", { onClick: handleToRegister }, "立即注册")
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"]))
              : _createCommentVNode("", true),
            (showUiIndex.value == 2)
              ? (_openBlock(), _createBlock(_component_el_form, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"cursor":"pointer"},
                          src: loginQrcode.value,
                          title: "点击刷新二维码",
                          alt: "",
                          onClick: reloadLoginQrcode
                        }, null, 8, _hoisted_16)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", { class: "login-ct-box-res" }, [
                      _hoisted_17,
                      _createElementVNode("span", { onClick: handleToRegister }, "立即注册")
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: require('@/assets/fd/reglog/login-1.jpg')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: require('@/assets/fd/reglog/login-2.jpg')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_image, {
              fit: "fill",
              src: require('@/assets/fd/reglog/login-3.jpg')
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})